export const DEFAULT_LOCALE = 'en-us';
export const DEFAULT_LANGUAGE = 'en';
export const getLanguage = wixCodeApi => {
  let language = wixCodeApi.site.language || DEFAULT_LANGUAGE;
  if (isMultilingualEnabled(wixCodeApi)) {
    language = wixCodeApi.window.multilingual.currentLanguage;
  }
  return language;
};
export const getLocale = wixCodeApi => {
  let locale = wixCodeApi.site.regionalSettings || DEFAULT_LOCALE;
  if (isMultilingualEnabled(wixCodeApi)) {
    var _wixCodeApi$window$mu;
    const currentLanguage = wixCodeApi.window.multilingual.currentLanguage;
    locale = ((_wixCodeApi$window$mu = wixCodeApi.window.multilingual.siteLanguages.find(language => language.languageCode === currentLanguage)) == null ? void 0 : _wixCodeApi$window$mu.locale) ?? locale;
  }
  const [language, region] = locale.split('-');
  return `${language}${region ? '-' + region.toUpperCase() : ''}`;
};
export const getRegionCode = wixCodeApi => {
  return getLocale(wixCodeApi).split('-')[1] || '';
};
const langugaeContainsRegion = lang => {
  return lang.split('-').length > 1;
};
export const getDateRegionalSettingsLocale = wixCodeApi => {
  const language = getLanguage(wixCodeApi);
  const region = getRegionCode(wixCodeApi);
  return region && !langugaeContainsRegion(language) ? `${language}-${region}` : language;
};
export const isMultilingualEnabled = wixCodeApi => {
  return wixCodeApi.window.multilingual.isEnabled;
};
//# sourceMappingURL=language.js.map